import { apiPost } from "./client";

export function getSiteUserStats(payload) {
  return apiPost("/siteuser-stats", payload);
}
